import { useState } from 'react'
import React from 'react'
import clsx from 'clsx'
import { Link } from 'gatsby'
import Button from '../Button/Button'
import Icon from '../Icon/Icon'

import logoNav from '../../images/logov2.svg'

import './navbar.scss'

import { hideBodyScroll, showBodyScroll } from '../../utils/helpers'
import { navigate } from '@reach/router'
import {
  locationLinks,
  occupancyLinks,
  projectTypeLinks,
  statusLinks,
} from './filterItems'
const urlBuilder = (submenu, value) => {
  const params = {
    location: submenu === 'location' ? value : 'location',
    occupancy: submenu == 'occupancy' ? value : 'occupancy',
    type: submenu == 'type' ? value : 'project%20type',
    price: submenu == 'price' ? value : 'price',
    status: submenu == 'status' ? value : 'status',
  }
  return `/projects/?location=${params?.location}&occupancy=${params?.occupancy}&type=${params?.type}&price=${params?.price}&status=${params?.status}#filterbar`
}
const LinkGroup = ({ title, links, cols, submenu }) => {
  const chunks = []
  for (let i = 0; i < cols; i++) {
    if (i == 0) {
      const slice = links?.slice(0, links?.length / cols + 1)
      chunks?.push(slice)
    } else {
      const slice = links?.slice(
        (i * links?.length) / cols + 1,
        ((i + 1) * links?.length) / cols + 1
      )

      chunks?.push(slice)
    }
  }

  const handleClick = (item) => {
    navigate(urlBuilder(submenu, item))
  }

  return (
    <div className="flex flex-col gap-y-6 border-x-[1px] border-[#F3F3F4] p-10">
      <div className="text-[#868688] font-work-sans font-semibold leading-[18px] uppercase">
        {title}
      </div>

      <div className={`w-full flex gap-x-3`}>
        {chunks?.map((chunk, index) => (
          <div key={index} className="w-full flex flex-col gap-y-4">
            {chunk?.map((link, index) => (
              <div
                onClick={() => handleClick(link?.label)}
                to={link?.url}
                key={index}
                className="w-full text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans hover:font-semibold"
              >
                {link?.label}
              </div>
            ))}
          </div>
        ))}
      </div>
      {/* <div className={`flex flex-col`}>
        {links.map((link, index) => (
          <Link
            to={link.url}
            key={index}
            className="w-full text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans hover:font-semibold"
          >
            {link.label}
          </Link>
        ))}
      </div> */}
    </div>
  )
}


const MobileLinkGroup = ({ links, submenu, closeAll }) => {
  const handleClick = (item) => {
    navigate(urlBuilder(submenu, item))
    closeAll()
  }

  return (
    <div className="w-full px-6 flex gap-y-6 py-10 ">
      {/* <div className="text-[#868688] font-work-sans font-semibold leading-[18px] uppercase">
        {title}
      </div> */}
      <div className={`w-full flex flex-col gap-y-4`}>
        {links?.slice(0, links?.length / 2).map((link, index) => (
          <div
            onClick={() => handleClick(link?.label)}
            key={index}
            className="w-full text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans hover:font-semibold"
          >
            {link?.label}
          </div>
        ))}
      </div>
      <div className={`w-full flex flex-col gap-y-4`}>
        {links.slice(links.length / 2, links.length).map((link, index) => (
          <div
            onClick={() => handleClick(link.label)}
            key={index}
            className="w-full text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans hover:font-semibold"
          >
            {link.label}
          </div>
        ))}
      </div>
    </div>
  )
}

export const Navbar = ({ otherClasses, toggleFunc, projectLinks }) => {
  const navbarClasses = clsx(
    otherClasses,
    'w-full fixed top-0 left-0 z-20 bg-gray-900 py-2 lg:py-0'
  )

  const [toggle, setToggle] = useState(false)
  const toggleHandle = (elm) => {
    setToggle(!elm)
  }

  const [toggleMenu, setToggleMenu] = useState()
  const toggleMenuHandle = (elm) => {
    setToggleMenu(elm)
  }

  const [toggleSubmenu, setToggleSubMenu] = useState(false)
  const toggleSubMenuHandle = (elm) => {
    setToggleSubMenu(elm)
  }

  const closeAll = () => {
    setToggle(false)
    setToggleSubMenu(false)
  }
  if (toggle) {
    hideBodyScroll()
  } else {
    showBodyScroll()
  }

  return (
    <nav className={navbarClasses} id="navbar" data-testid="navbar">
      {!toggleSubmenu ? (
        <div className="max-w-[1512px] mx-auto w-full px-4 lg:px-10 flex items-center justify-between">
          <Link to="/">
            <img
              src={logoNav}
              alt="logo-navbar"
              className="w-[160px] lg:w-[226.563px] h-[41px] lg:h-[58px]"
            />
          </Link>
          <div
            className={clsx(
              toggle ? 'flex ' : 'hidden lg:flex',
              'absolute top-[57px] left-0 lg:left-auto lg:top-auto lg:static  flex-col py-8 px-6 lg:px-0 lg:py-0  lg:flex-row lg:items-center gap-6 lg:gap-8 xl:gap-10 bg-primary_heading_color lg:bg-transparent lg:w-auto w-full mobile_wrapper_container'
            )}
          >
            <ul className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8 xl:gap-10">
              <li className="lg:h-[74px] group flex gap-5 lg:gap-0 flex-col lg:flex-row items-center relative w-full lg:w-auto ">
                <Link
                  to="/about-us/"
                  className="text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  hidden items-center justify-between lg:block"
                >
                  About
                  <Icon
                    icon="white-arrow-down"
                    iconHeight={24}
                    iconWidth={24}
                    otherClasses="lg:hidden group-hover:rotate-180 transition duration-200"
                  />
                </Link>
                <button
                  onClick={() =>
                    toggleMenuHandle(toggleMenu === 'about' ? 0 : 'about')
                  }
                  className={clsx(
                    'text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  flex items-center justify-between lg:hidden hover:bg-gray-800 lg:hover:bg-transparent hover:rounded-full lg:hover:rounded-none py-1 px-3 lg:py-0 lg:px-0 active:outline active:outline-[2px] active:outline-primary_dark_blue_500',
                    toggleMenu === 'about' ? '' : ''
                  )}
                >
                  About
                  <Icon
                    icon="white-arrow-down"
                    iconHeight={24}
                    iconWidth={24}
                    otherClasses={clsx(
                      'lg:hidden transition duration-200',
                      toggleMenu === 'about' ? 'rotate-180' : ''
                    )}
                  />
                </button>
                <ul
                  className={clsx(
                    'w-full lg:absolute lg:top-[62px] lg:min-w-[200px] lg:bg-white lg:rounded-[10px] px-4 lg:py-2 flex-col gap-6 lg:gap-4 desk_box_shadow',
                    toggleMenu === 'about'
                      ? 'flex'
                      : 'hidden lg:group-hover:flex lg:hidden'
                  )}
                >
                  <Link
                    to="/about-us/"
                    className="text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans lg:hidden"
                  >
                    About Us
                  </Link>
                  <Link
                    to="/about-us/testimonials/"
                    className="text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans "
                  >
                    Testimonials
                  </Link>
                </ul>
              </li>
              <li className="lg:h-[74px] group flex gap-5 lg:gap-0 flex-col lg:flex-row items-center  w-full lg:w-auto ">
                <Link
                  to="/projects/"
                  className="text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  hidden items-center justify-between lg:block"
                >
                  Project
                </Link>
                <button
                  onClick={() =>
                    toggleMenuHandle(toggleMenu === 'projects' ? 0 : 'projects')
                  }
                  className={clsx(
                    'text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  flex items-center justify-between lg:hidden hover:bg-gray-800 lg:hover:bg-transparent hover:rounded-full lg:hover:rounded-none py-1 px-3 lg:py-0 lg:px-0 active:outline active:outline-[2px] active:outline-primary_dark_blue_500',
                    toggleMenu === 'projects' ? '' : ''
                  )}
                >
                  Projects
                  <Icon
                    icon="white-arrow-down"
                    iconHeight={24}
                    iconWidth={24}
                    otherClasses={clsx(
                      'lg:hidden transition duration-200',
                      toggleMenu === 'projects' ? 'rotate-180' : ''
                    )}
                  />
                </button>
                <ul
                  className={clsx(
                    'w-full lg:absolute lg:top-[62px] mx-auto lg:bg-transparent lg:rounded-[10px] flex-col gap-6 lg:gap-4 left-2/4 -translate-x-2/4 lg:min-w-[1024px]',
                    toggleMenu === 'projects'
                      ? 'hidden'
                      : 'hidden lg:group-hover:flex lg:hidden'
                  )}
                >
                  <Link
                    to="/projects/"
                    className="text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans lg:hidden"
                  >
                    Projects
                  </Link>
                  <div className='px-10 bg-transparent shadow-none'>

                  <div className="w-full grid grid-cols-[2fr_1fr_1fr_1fr] border_radius_nav bg-white lg:rounded-[10px]">
                    <LinkGroup
                      title="Location"
                      links={locationLinks}
                      cols={3}
                      submenu="location"
                    />
                    <LinkGroup
                      title="Project Type"
                      links={projectTypeLinks}
                      cols={1}
                      submenu="type"
                    />
                    <LinkGroup
                      title="Occupancy"
                      links={occupancyLinks}
                      cols={2}
                      submenu="occupancy"
                    />
                    <LinkGroup
                      title="Status"
                      links={statusLinks}
                      cols={1}
                      submenu="status"
                    />
                  </div>
                  </div>
                </ul>
                <ul
                  className={clsx(
                    'w-full lg:absolute lg:top-[62px] lg:left-0 lg:min-w-[200px] lg:bg-white lg:rounded-[10px] px-4 lg:py-2 flex-col gap-6 lg:gap-4 desk_box_shadow',
                    toggleMenu === 'projects' ? 'flex' : 'hidden '
                  )}
                >
                  <button
                    onClick={() => toggleSubMenuHandle('location')}
                    className={clsx(
                      'text-[12px] lg:text-sm leading-[18px] text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  flex items-center justify-between lg:hidden hover:bg-gray-800 lg:hover:bg-transparent hover:rounded-full lg:hover:rounded-none py-1 px-3 lg:py-0 lg:px-0 active:outline active:outline-[2px] active:outline-primary_dark_blue_500',
                      toggleMenu === 'locations' ? '' : ''
                    )}
                  >
                    Location
                  </button>
                  <button
                    onClick={() => toggleSubMenuHandle('type')}
                    className={clsx(
                      'text-[12px] lg:text-sm leading-[18px] text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  flex items-center justify-between lg:hidden hover:bg-gray-800 lg:hover:bg-transparent hover:rounded-full lg:hover:rounded-none py-1 px-3 lg:py-0 lg:px-0 active:outline active:outline-[2px] active:outline-primary_dark_blue_500',
                      toggleMenu === 'locations' ? '' : ''
                    )}
                  >
                    Project Type
                  </button>
                  <button
                    onClick={() => toggleSubMenuHandle('occupancy')}
                    className={clsx(
                      'text-[12px] lg:text-sm leading-[18px] text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  flex items-center justify-between lg:hidden hover:bg-gray-800 lg:hover:bg-transparent hover:rounded-full lg:hover:rounded-none py-1 px-3 lg:py-0 lg:px-0 active:outline active:outline-[2px] active:outline-primary_dark_blue_500',
                      toggleMenu === 'locations' ? '' : ''
                    )}
                  >
                    Occupancy
                  </button>
                  <button
                    onClick={() => toggleSubMenuHandle('status')}
                    className={clsx(
                      'text-[12px] lg:text-sm leading-[18px] text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  flex items-center justify-between lg:hidden hover:bg-gray-800 lg:hover:bg-transparent hover:rounded-full lg:hover:rounded-none py-1 px-3 lg:py-0 lg:px-0 active:outline active:outline-[2px] active:outline-primary_dark_blue_500',
                      toggleMenu === 'locations' ? '' : ''
                    )}
                  >
                    Status
                  </button>
                </ul>

                {/* <button
                onClick={() =>
                  toggleMenuHandle(toggleMenu === 'projects' ? 0 : 'projects')
                }
                className={clsx(
                  'text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  flex items-center justify-between lg:hidden hover:bg-gray-800 lg:hover:bg-transparent hover:rounded-full lg:hover:rounded-none py-1 px-3 lg:py-0 lg:px-0 active:outline active:outline-[2px] active:outline-primary_dark_blue_500',
                  toggleMenu === 'projects' ? '' : ''
                )}
              >
                Projects
                <Icon
                  icon="white-arrow-down"
                  iconHeight={24}
                  iconWidth={24}
                  otherClasses={clsx(
                    'lg:hidden transition duration-200',
                    toggleMenu === 'projects' ? 'rotate-180' : ''
                  )}
                />
              </button> */}
                {/* <ul
                className={clsx(
                  'w-full lg:absolute lg:top-[62px] lg:left-0 lg:min-w-[200px] lg:bg-white lg:rounded-[10px] px-4 lg:py-2 flex-col gap-6 lg:gap-4 desk_box_shadow lg:overflow-auto lg:max-h-[250px]',
                  toggleMenu === 'projects'
                    ? 'flex'
                    : 'hidden lg:group-hover:flex lg:hidden'
                )}
              >
                <li className="lg:hidden text-white lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans ">
                  <Link to={`/projects`}>Projects</Link>
                </li>
                {projectLinks.map(({ title, slug: { current } }, index) => {
                  return (
                    <li
                      key={index}
                      className="text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans "
                    >
                      <Link to={`/${current}`}>{title}</Link>
                    </li>
                  )
                })}
              </ul> */}
              </li>
              <li className="lg:h-[74px] group flex gap-5 lg:gap-0 flex-col lg:flex-row items-center relative w-full lg:w-auto ">
                <Link
                  to="/assignments-resale"
                  className="text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto flex px-3 items-center justify-between  hover:bg-gray-800  lg:hover:bg-transparent hover:rounded-full py-[7px] lg:px-0 lg:py-0"
                >
                  Assignments
                </Link>
              </li>
              <li className="lg:h-[74px] group flex gap-5 lg:gap-0 flex-col lg:flex-row items-center relative w-full lg:w-auto ">
                <Link
                  to="/resources/"
                  className="text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  hidden items-center justify-between lg:block"
                >
                  Resources
                  <Icon
                    icon="white-arrow-down"
                    iconHeight={24}
                    iconWidth={24}
                    otherClasses="lg:hidden group-hover:rotate-180 transition duration-200"
                  />
                </Link>
                <button
                  onClick={() =>
                    toggleMenuHandle(
                      toggleMenu === 'resources' ? 0 : 'resources'
                    )
                  }
                  className={clsx(
                    'text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 w-full lg:w-auto  flex items-center justify-between lg:hidden hover:bg-gray-800 lg:hover:bg-transparent hover:rounded-full lg:hover:rounded-none py-1 px-3 lg:py-0 lg:px-0 active:outline active:outline-[2px] active:outline-primary_dark_blue_500',
                    toggleMenu === 'resources' ? '' : ''
                  )}
                >
                  Resources
                  <Icon
                    icon="white-arrow-down"
                    iconHeight={24}
                    iconWidth={24}
                    otherClasses={clsx(
                      'lg:hidden transition duration-200',
                      toggleMenu === 'resources' ? 'rotate-180' : ''
                    )}
                  />
                </button>
                <ul
                  className={clsx(
                    'w-full lg:absolute lg:top-[62px] lg:left-0 lg:min-w-[200px] lg:bg-white lg:rounded-[10px] px-4 lg:py-2 flex-col gap-6 lg:gap-4 desk_box_shadow',
                    toggleMenu === 'resources'
                      ? 'flex'
                      : 'hidden lg:group-hover:flex lg:hidden'
                  )}
                >
                  <Link
                    to="/resources/"
                    className="lg:hidden text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans "
                  >
                    Resources
                  </Link>
                  <Link
                    to="/blog/"
                    className="text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans "
                  >
                    Blog
                  </Link>
                  <Link
                    to="/faqs/"
                    className="text-white  lg:text-primary_heading_color text-sm leading-[20px] font-normal font-work-sans "
                  >
                    FAQs
                  </Link>
                </ul>
              </li>
              <li className="lg:h-[74px] group flex items-center relative w-full lg:w-auto pb-1 pt-8 border-t-[1px] border-t-white/25 px-3 lg:border-t-[0px]  lg:py-0 lg:px-0 ">
                <Link
                  to="/resources/worksheet/"
                  className="text-[12px] lg:text-sm leading-[18px] font-semibold text-white font-work-sans tracking-[0.36px] lg:tracking-[0.42px] lg:group-hover:text-primary_dark_blue_500 lg:pl-8 xl:pl-10 lg:border-l-[1px] lg:border-l-white/25 w-full lg:w-auto"
                >
                  Reserve Your Unit
                </Link>
              </li>
            </ul>
            <Button
              label="Contact Us"
              variant="primary"
              otherClasses="w-fit"
              onClick={() => toggleFunc('Contact Us')}
            />
          </div>
          <div className="lg:hidden flex items-center gap-2">
            <a
              href="tel:647-697-9595"
              className="p-2 hover:bg-gray-800 rounded-[10px] focus:outline focus:outline-[2px] focus:bg-transparent active:bg-gray-800 focus:outline-primary_dark_blue_500"
            >
              <Icon icon="phone-icon" iconHeight={24} iconWidth={24} />
            </a>
            <button
              onClick={() => toggleHandle(toggle)}
              className={clsx(
                'p-2 rounded-[10px] hover:bg-gray-800',
                toggle
                  ? 'outline-primary_dark_blue_500 outline outline-[2px] bg-gray-800'
                  : ''
              )}
            >
              <Icon
                icon={toggle ? 'cancel-icon' : 'hamburger'}
                iconHeight={24}
                iconWidth={24}
              />
            </button>
          </div>
        </div>
      ) : (
        <div className="max-w-[1512px] h-full mx-auto w-full flex items-center justify-between flex-col">
          <div className="flex justify-between border-b-[1px] border-[#F2F6FD] w-full px-6 py-4">
            <Icon
              icon="nav-back-icon"
              iconHeight={24}
              iconWidth={24}
              onClick={() => toggleSubMenuHandle(false)}
            />
            <div className="text-white font-work-sans">Menu</div>
            <Icon
              icon="nav-close-icon"
              iconHeight={24}
              iconWidth={24}
              onClick={() => {
                //toggleSubMenuHandle(false)
                toggleHandle(toggle)
              }}
            />
          </div>
          <div className="bg-primary_heading_color w-full">
            {toggleSubmenu === 'location' && (
              <MobileLinkGroup
                links={locationLinks}
                submenu={toggleSubmenu}
                closeAll={closeAll}
              />
            )}
          </div>
          <div className="bg-primary_heading_color w-full">
            {toggleSubmenu === 'type' && (
              <MobileLinkGroup
                links={projectTypeLinks}
                submenu={toggleSubmenu}
                closeAll={closeAll}
              />
            )}
          </div>
          <div className="bg-primary_heading_color w-full">
            {toggleSubmenu === 'occupancy' && (
              <MobileLinkGroup
                links={occupancyLinks}
                submenu={toggleSubmenu}
                closeAll={closeAll}
              />
            )}
          </div>
          <div className="bg-primary_heading_color w-full">
            {toggleSubmenu === 'status' && (
              <MobileLinkGroup
                links={statusLinks}
                submenu={toggleSubmenu}
                closeAll={closeAll}
              />
            )}
          </div>
        </div>
      )}
    </nav>
  )
}

export default Navbar
